import { FlatFolderTreeItem } from "@zapier/bff";
import { Members } from "../../member/useMembers";

export function mapOwnersToFoldersHash(
  hash: Record<string, FlatFolderTreeItem>,
  members: Members,
) {
  return Object.keys(hash).reduce(
    (accumulator, key) => {
      const folder = hash[key];
      const owner = folder?.ownerId ? members[folder.ownerId] : undefined;
      if (owner) {
        accumulator[key] = {
          ...folder,
          owner,
        };
      }
      return accumulator;
    },
    { ...hash },
  );
}
